import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ToggleOption<T = string | number> {
  value: T;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  standalone: false
})
export class ToggleComponent<T = string | number> {
  @Input() options: ToggleOption<T>[] = [];
  @Input() activeValue: T | null = null;
  @Input() className: string = '';
  @Output() valueChange = new EventEmitter<T>();

  select(value: T) {
    this.valueChange.emit(value);
  }

  isActive(value: T): boolean {
    return this.activeValue === value;
  }
}
